<script setup>
import { useWorkspaceV2 } from 'dashboard/composables/useWorkspaceV2';
import Banner from 'dashboard/components-next/banner/Banner.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  context: {
    type: String,
    default: '',
  },
  canReset: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['reset', 'retry']);
const { isWorkspaceV2 } = useWorkspaceV2();
</script>

<template>
  <section
    v-if="isWorkspaceV2"
    class="flex flex-col gap-4 rounded-2xl border border-n-weak bg-n-solid-1 p-4"
    data-testid="report-filter-panel"
  >
    <header class="flex flex-wrap items-start justify-between gap-3">
      <div class="min-w-0">
        <h2 class="text-sm font-semibold text-n-slate-12">
          {{ $t('REPORT.FILTER_PANEL.TITLE') }}
        </h2>
        <p
          v-if="context"
          class="mt-1 text-xs leading-5 text-n-slate-11"
          data-testid="report-filter-context"
        >
          {{ context }}
        </p>
      </div>
      <Button
        v-if="canReset"
        :label="$t('REPORT.FILTER_PANEL.RESET')"
        icon="i-ph-arrow-counter-clockwise"
        color="slate"
        variant="ghost"
        size="sm"
        :disabled="disabled"
        data-testid="report-filter-reset"
        @click="emit('reset')"
      />
    </header>

    <div class="min-w-0">
      <slot />
    </div>

    <Banner
      v-if="errorMessage"
      color="ruby"
      :action-label="$t('REPORT.FILTER_PANEL.RETRY')"
      data-testid="report-filter-error"
      @action="emit('retry')"
    >
      {{ errorMessage }}
    </Banner>
  </section>

  <slot v-else />
</template>
